import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { Subscription, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { CommSummaryModel } from '../../models/commissionsummary/commsummary.model';
import { CommissionSummaryService } from '../../service/commission-summary.service';
import { ReportsService } from '../../service/reports.service';
import { GlobalService } from 'src/app/service/global.service';
import { ReviewCommissionsService } from 'src/app/service/commission-summary/review-commissions.service';
import { HomeModel } from 'src/app/models/home/home.model';
import { HomeService } from 'src/app/service/home.service';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { CalendarModel } from 'src/app/models/config/calendar.model';
import { CalendarService } from 'src/app/service/calendar.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { MatTableDataSource } from '@angular/material/table';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { ExcelHeadersService } from 'src/app/service/excelheaders.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-search-reports-view',
  templateUrl: './search-reports-view.component.html',
  styleUrls: ['./search-reports-view.component.css']
})
export class SearchReportsViewComponent implements OnInit, OnDestroy {

  public commSummaryModel = new CommSummaryModel();

  private subscriptions: Subscription[] = [];

  dropDownsData: CommSummaryModel[] = [];
  adminConfigList: CommSummaryModel[] = [];
  filteredSalesChannelsData: CommSummaryModel[] = [];
  filteredCommPlansData: CommSummaryModel[] = [];
  filteredValidToDatesData: CommSummaryModel[] = [];
  getValidToDate: CommSummaryModel[] = [];
  effectiveDateData: CommSummaryModel[] = [];
  commplansdata: Array<HomeModel | AddUser> = [];

  searchCriteriaSet = new Set<string>();
  loggedincommplanid: number = 0;

  public effectiveDate: string | Date = '';

  isReportTypeHide: boolean = true;
  isReportTypeHide1: boolean = true;
  isReportTypeHideUsers: boolean = false;
  isReportTypeHideUsersPR: boolean = false;
  isReportTypeKPIEnterprise: boolean = false;
  isEnterpriseHistoricalReport: boolean = false;

  userModel = new AddUser();
  calData: CalendarModel[];
  comPlansUserData: AddUser[] = [];
  allComPlansUserData: AddUser[] = [];
  public dataForHeadersExcel = [];
  resultForExcel = [];

  public curDate: string = '';
  public prevDateOne: string = '';
  public prevDateTwo: string = '';

  userTypes: string[] = [];
  salesRepTypes: string[] = [];
  payrollCalender: string[] = [];
  salesChnlsUserData: AddUser[] = [];
  salesChannels: string[] = [];
  userData: AddUser[] = [];
  userModel1 = new AddUser();
  filteredUserData: AddUser[] = [];
  exportExcelUserData: AddUser[] = [];
  public dataSource = new MatTableDataSource<AddUser>();

  columnsExcelData: Array<{ id?: number; name: string; pagename: string; dataKey?: string; datakey?: string; position?: string | number }> = [];
  ordersTableExcelHeaderColumns: TableColumn[] = [];

  userRole: string = '';
  employeeId: string = '';
  personnelProfileStatus = 'complete';
  readonly personnelProfileStatusOptions = [
    { label: 'Active', value: 'complete' },
    { label: 'Inactive', value: 'inactive' },
    { label: 'Pending', value: 'pending' },
    { label: 'All', value: 'all' },
  ];
  allowedReportTypes: CommSummaryModel[] = [];
  isSalesChannelAdmin: boolean = false;

  constructor(private router: Router, private reportsService: ReportsService, private calendarService: CalendarService, public ete: ExportExcelService, private excelHeadersService: ExcelHeadersService, private commissionSummaryService: CommissionSummaryService,
    private manageUserService: ManageUserService, private notificationService: NotificationService, private homeService: HomeService, private globalService: GlobalService) {
    globalService._disableBackButton();
  }

  ngOnInit() {
    this.userRole = localStorage.getItem('CURRENT_USERROLE_SESSION') || '';
    this.employeeId = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION') || '';
    this.isSalesChannelAdmin = this.userRole === 'Sales Channel Admin';


    this.getAdminConfigData();
    this.getPrePopulatedUserData();
    this.getCommplansList();
    this.getDropDownsData();

    this.commSummaryModel.reporttype = "0";
    this.loadDefaults();
    this.filterData(this.commSummaryModel.reporttype);

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  getReport(): void {
    this.normalizeSelectedCommissionPlans();

    if (this.commSummaryModel.reporttype === "null" || this.commSummaryModel.reporttype === null || this.commSummaryModel.reporttype === "0") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Report Type');
      return;
    }

    if (this.isEnterpriseHistoricalReport) {
      if (this.commSummaryModel.salesChannel === "null" || this.commSummaryModel.salesChannel === null) {
        this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Sales Channel');
        return;
      }

      this.persistReportSelections();

      this.reportsService.downloadZip(
        this.commSummaryModel.reporttype,
        'NA',
        'NA',
        'NA',
        this.commSummaryModel.salesChannel
      ).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.commSummaryModel.reporttype + `.zip`;
        a.click();
        window.URL.revokeObjectURL(url);
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      });
      return;
    }

    this.persistReportSelections();

    const isDumpReport = this.commSummaryModel.reporttype === 'DumpEnterpriseDetails'
      || this.commSummaryModel.reporttype?.startsWith('Dump');
    const isScwReport = this.commSummaryModel.reporttype === 'SCWLegacyCommissions';
    const isTransactionReport = this.commSummaryModel.reporttype === 'EnterpriseTransactionReport';
    const requiresCommPlan = !isScwReport;
    const requiresPayrollEndDate = !isDumpReport && !isScwReport && !isTransactionReport
      && !this.isReportTypeKPIEnterprise && this.isReportTypeHide;
    const usePlaceholderPayrollParams = isDumpReport || isScwReport || isTransactionReport;

    if (this.commSummaryModel.salesChannel === "null" || this.commSummaryModel.salesChannel === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Sales Channel');
    } else if (requiresCommPlan && (!this.commSummaryModel.commPlanId || this.commSummaryModel.commPlanId.length === 0)) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Commission Plan');
    } else if (requiresPayrollEndDate && (this.commSummaryModel.calRunId === "null" || this.commSummaryModel.calRunId === null || this.commSummaryModel.calRunId === "")) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Payroll End Date');
    } else {
      const payrollEndDate = usePlaceholderPayrollParams ? 'NA' : this.getSelectedPayrollEndDateValue();
      const calRunId = usePlaceholderPayrollParams ? '0' : this.commSummaryModel.calRunId;
      const commPlanId = isScwReport ? '0' : this.formatCommPlanIdsForRequest();
      if (this.commSummaryModel.reporttype === 'EnterpriseReports' || this.commSummaryModel.reporttype === 'EnterpriseReleaseReports') {
        this.reportsService.downloadKpiEnterpriseZip(
          this.commSummaryModel.reporttype,
          commPlanId,
          [this.commSummaryModel.calRunIds.join(',')],
          payrollEndDate,
          this.commSummaryModel.salesChannel
        ).subscribe(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = this.commSummaryModel.reporttype + `.zip`;
          a.click();
          window.URL.revokeObjectURL(url);
        }, (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
        });
      } else {
        this.reportsService.downloadZip(
          this.commSummaryModel.reporttype,
          commPlanId,
          calRunId,
          payrollEndDate,
          this.commSummaryModel.salesChannel
        ).subscribe(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = this.commSummaryModel.reporttype + `.zip`;
          a.click();
          window.URL.revokeObjectURL(url);
        }, (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
        });

      }
    }
  }

  public getAdminConfigData(): void {
    this.commissionSummaryService.getAdminConfigData().subscribe(
      (response: CommSummaryModel[]) => {
        this.adminConfigList = response;

        if (this.isSalesChannelAdmin) {
          // Retention monthly reuses standard MonthlyDetailComm (not a Retention-only type).
          this.allowedReportTypes = this.adminConfigList.filter(report =>
            report.field_short_name === 'CommsByKPICrossTabReport' ||
            report.field_short_name === 'MonthlyDetailComm' ||
            report.field_short_name === 'RetentionCommsByKPIReport' ||
            report.field_short_name === 'RetentionTransactionalDetailReport'
          );
        } else {
          this.allowedReportTypes = this.adminConfigList;
        }
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      }
    )
  }

  public getDropDownsData(): void {
    this.subscriptions.push(
      (this.isSalesChannelAdmin
        ? this.commissionSummaryService.getSalesChannelAdminDropDownsData(this.employeeId)
        : this.commissionSummaryService.getDropDownsData()
      ).subscribe(
        (response: CommSummaryModel[]) => {
          this.dropDownsData = response;

          this.filteredSalesChannelsData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.salesChannel != "" && item.salesChannel == v.salesChannel) === i);
          this.filteredSalesChannelsData = this.filteredSalesChannelsData.sort((a, b) => (a.salesChannel < b.salesChannel) ? -1 : 1);

          this.filteredValidToDatesData = this.buildPayrollEndDateOptions(this.dropDownsData);

          const cachedCalRunId = localStorage.getItem('calrunid');
          if (cachedCalRunId && cachedCalRunId.length > 0) {
            const filterValue = this.globalService._normalizeValue(cachedCalRunId);
            this.getValidToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getValidToDate = this.getValidToDate.filter((v, i) => this.getValidToDate.findIndex(item => item.validFromDt == v.validFromDt) === i);
            this.getValidToDate = this.getValidToDate.sort((a, b) => (a.validFromDt < b.validFromDt) ? -1 : 1);
            localStorage.setItem('calrunid', this.commSummaryModel.calRunId);
          }

          if (this.getValidToDate && this.getValidToDate.length > 0) {
            localStorage.setItem('validToDt', this.normalizePayrollDateForRequest(this.getValidToDate[0].validToDt));
          }

          this.loadDefaults();

        }, (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
        }
      )
    );
  }

  public getSelectedSc(_event: Event) {
    this.onReportSalesChannelChange(this.commSummaryModel.salesChannel);
  }

  onReportSalesChannelChange(salesChannel: string | null): void {
    this.commSummaryModel.commPlanId = null;
    this.commSummaryModel.calRunId = null;
    this.updateDependentDropdowns(salesChannel);
  }

  onUserSalesChannelChange(): void {
    const selectedChannel = this.salesChnlsUserData.find(
      channel => channel.sales_rep_channel === this.userModel.sales_rep_channel
    );
    if (selectedChannel) {
      this.userModel.sales_rep_channel_desc = selectedChannel.sales_rep_channel_desc;
    }
    this.filterCommissionPlansBySalesChannel();
  }


  public getSelectedPayrollCalendar(event: Event) {
    const filterValue = this.globalService._normalizeValue(this.commSummaryModel.calRunId);
    this.getValidToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
    this.getValidToDate = this.getValidToDate.filter((v, i) => this.getValidToDate.findIndex(item => item.validFromDt == v.validFromDt) === i);
    this.getValidToDate = this.getValidToDate.sort((a, b) => (a.validFromDt < b.validFromDt) ? -1 : 1);
    if (this.getValidToDate.length > 0) {
      localStorage.setItem('validToDt', this.normalizePayrollDateForRequest(this.getValidToDate[0].validToDt));
    }
  }

  public getSelectedPayrollCalendarForKPIEnterprise(): void {
    if (!this.commSummaryModel.calRunIds?.length) {
      return;
    }
    const selected = this.filteredValidToDatesData.find(item => String(item.calRunId) === String(this.commSummaryModel.calRunIds[0]));
    if (selected?.validToDt) {
      localStorage.setItem('validToDt', this.normalizePayrollDateForRequest(selected.validToDt));
    }
  }

  private getSelectedPayrollEndDateValue(): string {
    if (this.isReportTypeKPIEnterprise) {
      return this.normalizePayrollDateForRequest(localStorage.getItem('validToDt'));
    }
    const selectedCalRun = this.commSummaryModel.calRunId;
    if (selectedCalRun != null && selectedCalRun !== '') {
      const selected = this.filteredValidToDatesData.find(item => String(item.calRunId) === String(selectedCalRun));
      if (selected?.validToDt) {
        const value = this.normalizePayrollDateForRequest(selected.validToDt);
        if (value) {
          localStorage.setItem('validToDt', value);
          return value;
        }
      }
    }
    return this.normalizePayrollDateForRequest(localStorage.getItem('validToDt'));
  }

  private normalizePayrollDateForRequest(value: unknown): string {
    return ReviewCommissionsService.toStoredDateValue(value);
  }

  private formatCommPlanIdsForRequest(): string {
    const rawValue = this.commSummaryModel.commPlanId as unknown;
    if (rawValue == null || rawValue === '') {
      return '';
    }
    const values = Array.isArray(rawValue) ? rawValue : [rawValue];
    return values
      .map((value: unknown) => Number(value))
      .filter((value: number) => Number.isInteger(value) && value > 0)
      .join(',');
  }

  public loadDefaults() {
    this.commSummaryModel.reporttype = localStorage.getItem('reporttype');
    this.commSummaryModel.salesChannel = localStorage.getItem('sc');
    const storedCommPlans = localStorage.getItem('commplan');
    if (storedCommPlans) {
      try {
        this.commSummaryModel.commPlanId = JSON.parse(storedCommPlans);
      } catch {
        this.commSummaryModel.commPlanId = storedCommPlans.split(',').map((x: string) => Number(x)).filter((x: number) => Number.isInteger(x) && x > 0);
      }
    } else {
      this.commSummaryModel.commPlanId = null;
    }
    this.normalizeSelectedCommissionPlans();
    this.commSummaryModel.calRunId = localStorage.getItem('calrunid');

    this.getDefaults(this.commSummaryModel.salesChannel);
  }

  public getDefaults(event: string | null) {
    this.updateDependentDropdowns(event);
  }

  private updateDependentDropdowns(salesChannel: string | null): void {
    const filterValue = this._normalizeValue(salesChannel);
    const channelScopedData = this.dropDownsData.filter(item => this._normalizeValue(item.salesChannel).startsWith(filterValue));

    this.filteredCommPlansData = channelScopedData
      .filter((v, i) => channelScopedData.findIndex(item => item.commPlan == v.commPlan) === i)
      .sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

    this.filteredValidToDatesData = this.buildPayrollEndDateOptions(channelScopedData);

    this.reconcileSelectedCommissionPlans();
  }

  /** Payroll End Date dropdown only — matches Commission Report getPayrollDates(). */
  private buildPayrollEndDateOptions(data: CommSummaryModel[]): CommSummaryModel[] {
    const currentYearMonth = new Date().getFullYear() * 100 + (new Date().getMonth() + 1);
    const sorted = [...data]
      .filter(item => item.pay_dt != null)
      .filter(item => {
        const calRunId = Number(item.calRunId);
        return Number.isNaN(calRunId) || calRunId <= currentYearMonth;
      })
      .sort((a, b) => {
        const endDiff = new Date(b.validToDt).getTime() - new Date(a.validToDt).getTime();
        return endDiff !== 0 ? endDiff : Number(b.calRunId) - Number(a.calRunId);
      });

    return sorted
      .filter((v, i) => sorted.findIndex(item => String(item.calRunId) === String(v.calRunId)) === i)
      .sort((a, b) => Number(b.calRunId) - Number(a.calRunId));
  }

  private normalizeSelectedCommissionPlans(): void {
    const rawValue = this.commSummaryModel.commPlanId as unknown;
    if (rawValue == null || rawValue === '') {
      this.commSummaryModel.commPlanId = null;
      return;
    }
    const values = Array.isArray(rawValue) ? rawValue : [rawValue];
    const normalized = values
      .map((value: unknown) => Number(value))
      .filter((value: number) => Number.isInteger(value) && value > 0);
    this.commSummaryModel.commPlanId = normalized.length ? normalized : null;
  }

  private reconcileSelectedCommissionPlans(): void {
    this.normalizeSelectedCommissionPlans();
    if (!this.commSummaryModel.commPlanId?.length) {
      return;
    }
    const availableIds = new Set(this.filteredCommPlansData.map(item => Number(item.commPlanId)));
    const filtered = this.commSummaryModel.commPlanId.filter((id: number) => availableIds.has(Number(id)));
    this.commSummaryModel.commPlanId = filtered.length ? filtered : null;
  }

  getCommplansList() {
    this.homeService.getCommplansList(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'), localStorage.getItem('CURRENT_USERROLE_SESSION'))
      .subscribe((data: HomeModel[]) => {
        this.commplansdata = data;
        if (data.length > 0) {
          this.loggedincommplanid = this.commplansdata[0].comm_plan_id;
        }

      },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
        });
  }


  getPrePopulatedUserData() {
    this.salesChnlsUserData = [];
    this.userTypes = [];
    this.comPlansUserData = [];
    this.allComPlansUserData = [];
    this.salesRepTypes = [];
    this.payrollCalender = [];
    this.salesChannels = [];

    forkJoin({
      fields: this.manageUserService.getPrePopulatedUserData(),
      calData: this.calendarService.getCalData()
    }).subscribe({
      next: ({ fields, calData }) => {
        this.userData = fields;
        for (const userInfo of fields) {
          if (userInfo.commission_plan != null) {
            this.allComPlansUserData.push(userInfo);
          } else if (userInfo.sales_rep_channel != null && userInfo.sales_rep_channel_desc != null) {
            this.salesChnlsUserData.push(userInfo);
            this.salesChannels.push(userInfo.sales_rep_channel);
          } else if (userInfo.user_type != null) {
            this.userTypes.push(userInfo.user_type);
          } else if (userInfo.sales_rep_type != null) {
            this.salesRepTypes.push(userInfo.sales_rep_type);
          } else if (userInfo.calendar_type != null) {
            this.payrollCalender.push(userInfo.calendar_type);
          }
        }

        if (this.salesChannels.length > 1) {
          this.salesChannels.sort((a, b) => a.localeCompare(b));
        }
        if (this.userTypes.length > 1) {
          this.userTypes.sort((a, b) => a.localeCompare(b));
        }
        if (this.salesRepTypes.length > 1) {
          this.salesRepTypes.sort((a, b) => a.localeCompare(b));
        }
        if (this.payrollCalender.length > 1) {
          this.payrollCalender.sort((a, b) => a.localeCompare(b));
        }

        this.filterCommissionPlansBySalesChannel();
        this.manageUserService.salesChnlsUserData = this.salesChnlsUserData;
        this.manageUserService.userTypes = this.userTypes;
        this.manageUserService.comPlansUserData = this.comPlansUserData;
        this.manageUserService.salesRepTypes = this.salesRepTypes;
        this.manageUserService.payrollCalender = this.payrollCalender;
        this.calData = calData;
      },
      error: (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      }
    });
  }

  filterData(value: string) {
    if (value === "Users") {
      this.isReportTypeHide = false;
      this.isReportTypeHide1 = false;
      this.isReportTypeHideUsers = true;
      this.isReportTypeHideUsersPR = false;
      this.isReportTypeKPIEnterprise = false;
      this.isEnterpriseHistoricalReport = false;
      this.personnelProfileStatus = 'complete';
      this.filterCommissionPlansBySalesChannel();
    } else if (value === "UserCompPlanAssignments") {
      this.isReportTypeHide = false;
      this.isReportTypeHide1 = false;
      this.isReportTypeHideUsers = false;
      this.isReportTypeHideUsersPR = true;
      this.isReportTypeKPIEnterprise = false;
      this.isEnterpriseHistoricalReport = false;
    } else if (value === 'EnterpriseHistoricalData') {
      this.isEnterpriseHistoricalReport = true;
      this.isReportTypeHide1 = false;
      this.isReportTypeHide = false;
      this.isReportTypeHideUsers = false;
      this.isReportTypeHideUsersPR = false;
      this.isReportTypeKPIEnterprise = false;
    } else if (value === 'DumpEnterpriseDetails') {
      this.isReportTypeHide1 = true;
      this.isReportTypeHide = false;
      this.isReportTypeHideUsers = false;
      this.isReportTypeHideUsersPR = false;
      this.isReportTypeKPIEnterprise = false;
      this.isEnterpriseHistoricalReport = false;
    } else if (value === 'EnterpriseReports' || value === 'EnterpriseReleaseReports') {
      this.isReportTypeKPIEnterprise = true;
      this.isReportTypeHide = true;
      this.isReportTypeHide1 = true;
      this.isReportTypeHideUsersPR = false;
      this.isReportTypeHideUsers = false;
      this.isEnterpriseHistoricalReport = false;
    } else {
      this.isReportTypeHide1 = true;
      this.isReportTypeHide = true;
      this.isReportTypeHideUsers = false;
      this.isReportTypeHideUsersPR = false;
      this.isReportTypeKPIEnterprise = false;
      this.isEnterpriseHistoricalReport = false;
    }
  }

  getCalData() {
    this.calendarService.getCalData().subscribe(
      (response: CalendarModel[]) => {
        this.calData = response;
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      }
    )
  }


  exportToExcelFileSaver(): void {
    this.exportToExcel(JSON.parse(JSON.stringify(this.commplansdata)), 'my-data');
  }

  exportToExcel(data: Record<string, unknown>[], fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, fileName + '.xlsx');
  }

  exportCommsResultUserExcel() {
    this.exportExcelUserData = JSON.parse(JSON.stringify(this.commplansdata));

    for (let js of this.exportExcelUserData) {
      delete js.first_name;
      delete js.last_name;
      delete js.email_address;
      delete js.user_role;
      delete js.supervisor_id;
      delete js.curDate;
      delete js.prevDateOne;
      delete js.prevDateTwo;
      delete js.calendar_type;
    }

    this.exportExcelUserData.forEach((row: AddUser) => {
      if (row.comm_plan_id != null) {
        row.comm_plan_id = String(row.comm_plan_id).replace('$', '').trim() as any;
      }
    });

    const reportData = {
      title: this.commSummaryModel.reporttype,
      data: this.mapRowsToExportData(this.exportExcelUserData, this.ordersTableExcelHeaderColumns),
      headers: this.getExportHeaderNames(this.ordersTableExcelHeaderColumns),
      applyCommissionFormatting: false
    };
    this.ete.exportExcel(reportData);
    this.router.navigate(['/search-report-view']);
  }

  exportCommsResultExcel() {
    this.exportExcelUserData = JSON.parse(JSON.stringify(this.commplansdata));
    const reportData = {
      title: this.commSummaryModel.reporttype,
      data: this.mapRowsToExportData(
        this.exportExcelUserData,
        this.normalizeExportColumns(this.exportExcelUserData[0] ? Object.keys(this.exportExcelUserData[0]) : [])
      ),
      headers: this.getExportHeaderNames(
        this.normalizeExportColumns(this.exportExcelUserData[0] ? Object.keys(this.exportExcelUserData[0]) : [])
      )
    };
    this.ete.exportExcel(reportData);
    this.router.navigate(['/search-report-view']);
  }

  downloadFile(data1, filename = 'Report') {
    let csvData = this.ConvertToCSV(data1.data, data1.headers);
    let blob = new Blob(['\ufeff' + csvData],
      { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') !=
      -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {

      // If Safari open in new window to
      // save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", this.commSummaryModel.reporttype + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(dataRows: unknown[][], headerList: string[]) {
    const escapeCsvField = (value: unknown): string => {
      if (value == null) {
        return '';
      }
      const text = String(value);
      const escaped = text.replace(/"/g, '""');
      if (/^0\d+$/.test(text)) {
        return `"\t${escaped}"`;
      }
      if (/[",\r\n]/.test(text)) {
        return `"${escaped}"`;
      }
      return text;
    };

    let csv = headerList.map(escapeCsvField).join(',') + '\r\n';
    for (const row of dataRows) {
      csv += row.map(escapeCsvField).join(',') + '\r\n';
    }
    return csv;
  }

  downloadCompPlanReport() {
    this.persistReportSelections();
    this.reportsService.downloadCompPlanReport()
      .subscribe((data: AddUser[]) => {
        this.userData = data;
        this.exportPRResultExcel();
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      });
  }

  downloadPersonnelReport(): void {
    this.userSearch(this.personnelProfileStatus || 'complete');
  }

  userSearch(profilestatus: string) {
    const searchModel = this.prepareUserSearchModel();
    if (!searchModel) {
      return;
    }

    const statuses = profilestatus === 'all'
      ? ['complete', 'inactive', 'pending']
      : [profilestatus];

    if (statuses.length === 1) {
      this.fetchUsersReport(statuses[0], searchModel).subscribe({
        next: (data) => this.handleUserSearchResults(data),
        error: (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
        }
      });
      return;
    }

    forkJoin(statuses.map(status => this.fetchUsersReport(status, searchModel))).subscribe({
      next: (results) => this.handleUserSearchResults([].concat(...results)),
      error: (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      }
    });
  }

  private prepareUserSearchModel(): AddUser | null {
    this.persistReportSelections();

    this.userModel1 = JSON.parse(JSON.stringify(this.userModel));
    if (this.userModel1.employeeId != null && this.userModel1.employeeId !== '') {
      this.userModel1.employeeId = String(this.userModel1.employeeId).trim();
    }
    if (this.userModel1.sales_rep_id != null && this.userModel1.sales_rep_id !== '') {
      this.userModel1.sales_rep_id = String(this.userModel1.sales_rep_id).trim();
    }

    if (!this.hasPersonnelSearchCriteria()) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please enter one or more search criteria");
      return null;
    }

    if (this.userModel1.first_name) {
    } else {
      this.userModel1.first_name = "NA";
    }

    if (this.userModel1.last_name) {
    } else {
      this.userModel1.last_name = "NA";
    }

    if (this.userModel1.employeeId) {
    } else {
      this.userModel1.employeeId = "NA";
    }

    if (this.userModel1.sales_rep_id) {
    } else {
      this.userModel1.sales_rep_id = "NA";
    }

    if (this.userModel1.user_type) {
    } else {
      this.userModel1.user_type = "NA";
    }

    if (this.userModel1.id) {
    } else {
      this.userModel1.id = "NA";
    }

    if (this.userModel1.supervisor_id) {
    } else {
      this.userModel1.supervisor_id = 0;
    }

    if (this.userModel1.comm_plan_id) {
    } else {
      this.userModel1.comm_plan_id = 0;
    }

    if (this.userModel1.sales_rep_channel) {
    } else {
      this.userModel1.sales_rep_channel = "NA";
    }

    if (this.userModel1.soft_termination_date) {
    } else {
      this.userModel1.soft_termination_date = null;
    }

    if (!this.userModel1.payroll_start_date) {
      this.userModel1.payroll_start_date = "null";
    }

    if (!this.userModel1.userRole) {
      this.userModel1.userRole = "null";
    }

    return this.userModel1;
  }

  private hasPersonnelSearchCriteria(): boolean {
    return !!(
      this.userModel.first_name?.trim() ||
      this.userModel.last_name?.trim() ||
      this.userModel.employeeId?.toString().trim() ||
      this.userModel.sales_rep_id?.toString().trim() ||
      this.userModel.id ||
      this.userModel.supervisor_id ||
      this.userModel.user_type ||
      this.userModel.sales_rep_channel ||
      this.userModel.comm_plan_id ||
      this.userModel.payroll_start_date ||
      this.userModel.soft_termination_date
    );
  }

  private fetchUsersReport(profilestatus: string, searchModel: AddUser) {
    return this.manageUserService.getUsers(
      profilestatus,
      searchModel.first_name,
      searchModel.last_name,
      searchModel.employeeId,
      searchModel.sales_rep_id,
      searchModel.soft_termination_date,
      searchModel.id,
      searchModel.supervisor_id,
      searchModel.user_type,
      searchModel.sales_rep_channel,
      searchModel.comm_plan_id,
      searchModel.payroll_start_date,
      searchModel.userRole
    );
  }

  private handleUserSearchResults(data: AddUser[]): void {
    if (!data?.length) {
      this.notificationService.sendNotification(NotificationType.ERROR, "No Match Found With Your Search Criteria");
      return;
    }

    this.commplansdata = data;
    this.commplansdata.forEach((row) => {
      if (row.curDate) {
        this.curDate = row.curDate;
      }
      if (row.prevDateOne) {
        this.prevDateOne = row.prevDateOne;
      }
      if (row.prevDateTwo) {
        this.prevDateTwo = row.prevDateTwo;
      }
    });
    this.initializeExcelHeaders();
  }

  filterUsers() {
    if (this.userModel.first_name) {
      const filterValue = this._normalizeValue(this.userModel.first_name);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.first_name).startsWith(filterValue));
      this.findData();
    }
    if (this.userModel.last_name) {

      const filterValue = this._normalizeValue(this.userModel.last_name);
      this.filteredUserData = (this.userData.filter(user => this._normalizeValue(user.last_name).startsWith(filterValue)));
      this.findData();
    }
    if (this.userModel.employeeId) {

      const filterValue = this._normalizeValue(this.userModel.employeeId);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.employeeId).startsWith(filterValue));
      this.findData();
    }
    if (this.userModel.id) {
      this.filteredUserData = this.userData.filter((user) => (user.id == this.userModel.id));
      this.findData();
    }
    if (this.userModel.supervisor_id) {
      this.filteredUserData = this.userData.filter((user) => (user.supervisor_id == this.userModel.supervisor_id));
      this.findData();
    }
    if (this.userModel.user_type) {
      const filterValue = this._normalizeValue(this.userModel.user_type);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.user_type).startsWith(filterValue));
      this.findData();
    }
    if (this.userModel.sales_rep_channel) {
      const filterValue = this._normalizeValue(this.userModel.sales_rep_channel);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.sales_rep_channel).startsWith(filterValue));
      this.findData();
    }
    if (this.userModel.comm_plan_id) {
      this.filteredUserData = this.userData.filter((user) => (user.comm_plan_id == this.userModel.comm_plan_id));
      this.findData();
    }
    if (this.userModel.payroll_start_date) {
      this.filteredUserData = this.userData.filter((user) =>
        (user.effective_date <= this.userModel.payroll_start_date));
      this.findData();
    }
    if (this.userModel.payroll_end_date) {
      this.userData.forEach((user: AddUser) => {
        if (user.soft_termination_date && user.soft_termination_date >= this.userModel.payroll_end_date) {
          this.filteredUserData.push(user);
          this.filteredUserData = this.filteredUserData.filter((v, i) => this.filteredUserData.findIndex(item => item.network_id == v.network_id) === i);
        }
      })
      this.findData();
    }

    if (this.filteredUserData.length > 0)
      this.dataSource.data = this.filteredUserData;
    else {
      this.notificationService.notify(NotificationType.ERROR, "No Match Found With Your Search Criteria");
      this.router.navigate(['/search-report-view']);
    }

    this.filteredUserData.forEach((data) => {
      this.curDate = data.curDate;
      this.prevDateOne = data.prevDateOne;
      this.prevDateTwo = data.prevDateTwo;
    });

    this.initializeExcelHeaders();

  }

  private findData() {
    if (this.filteredUserData.length > 0) {
      this.userData = this.filteredUserData;
    }
  }

  exportPRResultExcel() {
    this.exportExcelUserData = JSON.parse(JSON.stringify(this.userData));
    const reportData = this.buildExcelReportData(this.exportExcelUserData);
    this.ete.exportExcel(reportData);

    this.router.navigate(['/search-report-view']);
  }

  exportResultExcel() {
    this.exportExcelUserData = null;
    this.exportExcelUserData = JSON.parse(JSON.stringify(this.filteredUserData));

    for (let js of this.exportExcelUserData) {
      delete js.email_address;
      delete js.userRole;
      delete js.sales_rep_channel_desc;
      delete js.joining_date;
      delete js.work_status;
      delete js.termination_date;
      delete js.vacation_start_date;
      delete js.vacation_end_date;
      delete js.rowid;
      delete js.created_dt;
      delete js.created_by;
      delete js.updated_dt;
      delete js.updated_by;
      delete js.supervisor_name;
      delete js.supervisor_id
      delete js.supervisor_pref_name;
      delete js.pref_first_name;
      delete js.pref_last_name;
      delete js.std_hours;
      delete js.commPlanId;
      delete js.corp;
      delete js.language;
      delete js.commissionable;
      delete js.calendar_type;
      delete js.first_name;
      delete js.middle_name;
      delete js.last_name;
      delete js.activeCommPeriod;
      delete js.effective_date;
      delete js.soft_termination_date;
      delete js.curDate;
      delete js.prevDateOne;
      delete js.prevDateTwo;
      delete js.supname;
      delete js.sales_channel_desc;

      delete js.email_address;

      delete js.first_name;
      delete js.middle_name;
      delete js.last_name;
      delete js.userRole;
      delete js.sales_rep_channel_desc;

      delete js.joining_date;
      delete js.work_status;
      delete js.termination_date;
      delete js.vacation_start_date;
      delete js.vacation_end_date;

      delete js.commissionable;
      delete js.supervisor_id;
      delete js.calendar_type;
      delete js.created_by;
      delete js.created_dt;
      delete js.updated_by;
      delete js.updated_dt;

      delete js.supervisor_name;
      delete js.pref_first_name;
      delete js.pref_last_name;
      delete js.std_hours;
      delete js.commPlanId;
      delete js.corp;
      delete js.language;

      delete js.activeCommPeriod;
      delete js.curDate;
      delete js.prevDateOne;
      delete js.prevDateTwo;
      delete js.effective_date;
      delete js.supName;
      delete js.sales_channel_desc;
    }

    const reportData = {
      title: this.commSummaryModel.reporttype,
      data: this.mapRowsToExportData(this.exportExcelUserData, this.ordersTableExcelHeaderColumns),
      headers: this.getExportHeaderNames(this.ordersTableExcelHeaderColumns)
    };
    this.ete.exportExcel(reportData);

    this.router.navigate(['/search-report-view']);
  }

  initializeExcelHeaders(): void {
    this.excelHeadersService.getKPIExcelHeaders()
      .subscribe((data: Array<{ id?: number; name: string; pagename: string; dataKey?: string; datakey?: string; position?: string | number }>) => {
        this.columnsExcelData = JSON.parse(JSON.stringify(data));

        const reportHeaders = this.columnsExcelData
          .filter((kpi) => kpi.pagename === 'ExcelUsersReportData')
          .sort((a, b) => Number(a.id ?? 0) - Number(b.id ?? 0));

        this.ordersTableExcelHeaderColumns = reportHeaders.map((header) => ({
          name: this.resolveReportHeaderName(header.name, this.resolveHeaderDataKey(header)),
          dataKey: this.resolveHeaderDataKey(header)
        }));
        this.exportCommsResultUserExcel();


      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      });
  }

  public redirect(url: string, pageName: string) {
    if (this.commSummaryModel.reporttype === "null" || this.commSummaryModel.reporttype === null || this.commSummaryModel.reporttype === "0") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Report Type');
    } else if (this.commSummaryModel.salesChannel === "null" || this.commSummaryModel.salesChannel === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Sales Channel');
    } else if (this.commSummaryModel.commPlanId === "null" || this.commSummaryModel.commPlanId === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Commission Plan');
    } else {
      this.persistReportSelections();

      this.commSummaryModel.extra_sc_emp_id = 1;
      this.commSummaryModel.sc_emp_id = "NA";
      this.commSummaryModel.sup_extra_sc_emp_id = 1;
      this.commSummaryModel.sup_sc_emp_id = "NA";

      this.commissionSummaryService.commSummaryModel = this.commSummaryModel;
      this.commissionSummaryService.searchCriteriaSet = this.searchCriteriaSet;

      this.getEffectiveDate(this.commSummaryModel.commPlanId, url, pageName);
    }
  }
  private getEffectiveDate(commPlanId: number, url: string, pageName: string) {

    const filterValue = this._normalizeValue(commPlanId.toString());
    this.effectiveDateData = this.dropDownsData.filter(item => this._normalizeValue(item.commPlanId).startsWith(filterValue));

    this.effectiveDateData.forEach(jsonModel => {
      this.effectiveDate = jsonModel.effective_date;
    });

    localStorage.setItem('SESSION_EFFDATE', String(this.effectiveDate));

    this.router.navigate(['/' + url], { queryParams: { page: this.commSummaryModel.reporttype } });
  }

  public startCalc(): void {
    const formData = null;
    this.subscriptions.push(
      this.commissionSummaryService.startCalc(formData).subscribe(
        (_response: CommSummaryModel[]) => {
        }, (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
        }
      )
    );
  }


  clearSearchCriteria() {

    localStorage.removeItem('sc');
    localStorage.removeItem('commplan');
    localStorage.removeItem('calrunid');

    this.commSummaryModel.salesChannel = null;
    this.commSummaryModel.commPlanId = null;
    this.commSummaryModel.calRunId = null;

    this.getDropDownsData();
  }

  public redirectPage(url: string) {
    this.router.navigate(['/' + url]);
  }

  private filterCommissionPlansBySalesChannel(): void {
    const source = this.allComPlansUserData;

    if (!this.userModel.sales_rep_channel) {
      this.comPlansUserData = source.slice()
        .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);
      return;
    }

    const selectedChannel = this.salesChnlsUserData.find(
      channel => channel.sales_rep_channel === this.userModel.sales_rep_channel
    );
    const channelDesc = selectedChannel?.sales_rep_channel_desc ?? this.userModel.sales_rep_channel_desc;

    this.comPlansUserData = source
      .filter(plan => this.planMatchesSalesChannel(plan, this.userModel.sales_rep_channel, channelDesc))
      .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);

    if (this.userModel.comm_plan_id != null &&
      !this.comPlansUserData.some(plan => Number(plan.comm_plan_id) === Number(this.userModel.comm_plan_id))) {
      this.userModel.comm_plan_id = null;
    }
  }

  private planMatchesSalesChannel(plan: AddUser, channelCode: string, channelDesc: string): boolean {
    const planValues = [
      this._normalizeValue(plan.sales_rep_channel),
      this._normalizeValue(plan.sales_channel_desc),
    ].filter(value => value.length > 0);

    const matchTokens = [
      this._normalizeValue(channelCode),
      this._normalizeValue(channelDesc),
    ].filter(value => value.length > 0);

    for (const token of matchTokens) {
      for (const planValue of planValues) {
        if (planValue === token) {
          return true;
        }
        if (planValue.startsWith(token) || token.startsWith(planValue)) {
          return true;
        }
      }
    }
    return false;
  }

  private _normalizeValue(value: string | number | null | undefined): string {
    return (value ?? '').toString().toLowerCase().replace(/\s/g, '');
  }

  private persistReportSelections(): void {
    localStorage.setItem('sc', String(this.commSummaryModel.salesChannel ?? ''));
    localStorage.setItem('country', String(this.commSummaryModel.country ?? ''));
    localStorage.setItem('commplan', JSON.stringify(this.commSummaryModel.commPlanId ?? []));
    localStorage.setItem('calrunid', String(this.commSummaryModel.calRunId ?? ''));
    localStorage.setItem('reporttype', String(this.commSummaryModel.reporttype ?? ''));
  }

  private buildCsvReportData(dataRows: unknown[], headers: string[] | TableColumn[]): { title: string | null, data: unknown[][], headers: string[] } {
    const columns = this.normalizeExportColumns(headers);
    return {
      title: this.commSummaryModel.reporttype,
      data: this.mapRowsToExportData(dataRows, columns),
      headers: this.getExportHeaderNames(columns)
    };
  }

  private normalizeExportColumns(headers: string[] | TableColumn[]): TableColumn[] {
    if (!Array.isArray(headers) || !headers.length) {
      return [];
    }
    if (typeof headers[0] === 'object') {
      return headers as TableColumn[];
    }
    return (headers as string[]).map(name => ({ name, dataKey: name }));
  }

  private resolveReportHeaderName(name: string, dataKey?: string): string {
    if (dataKey === 'comm_plan_id' || name === 'Comm Plan Amount' || name === 'Commission Plan Amount') {
      return 'Commission Plan ID';
    }
    if (name === 'Comm Plan1') {
      return 'CommPlan ' + this.curDate;
    }
    if (name === 'Comm Plan2') {
      return 'CommPlan ' + this.prevDateOne;
    }
    if (name === 'Comm Plan3') {
      return 'CommPlan ' + this.prevDateTwo;
    }
    if (name === 'Supervisor1') {
      return 'Supervisor ' + this.curDate;
    }
    if (name === 'Supervisor2') {
      return 'Supervisor ' + this.prevDateOne;
    }
    if (name === 'Supervisor3') {
      return 'Supervisor ' + this.prevDateTwo;
    }
    return name;
  }

  private resolveHeaderDataKey(header: { dataKey?: string; datakey?: string; name: string }): string {
    return header.dataKey || header.datakey || header.name;
  }

  private getExportHeaderNames(columns: TableColumn[]): string[] {
    return columns.map(column => column.name);
  }

  private mapRowsToExportData(rows: unknown[], columns: TableColumn[]): unknown[][] {
    return rows.map(row => {
      const normalizedRow = this.normalizeUserReportExportRow(row as Record<string, unknown>);
      return columns.map(column => this.getExportCellValue(normalizedRow, column.dataKey));
    });
  }

  private normalizeUserReportExportRow(row: Record<string, unknown>): Record<string, unknown> {
    return {
      ...row,
      employee_id: this.asExportTextId(row.employee_id ?? row.employeeId),
      sc_emp_id: this.asExportTextId(row.sc_emp_id ?? row.id),
      sales_rep_id: this.asExportTextId(row.sales_rep_id),
      complan1: row.complan1 ?? row.commission_plan,
      complan2: row.complan2 ?? row.comPlanTwo,
      complan3: row.complan3 ?? row.comPlanThree,
      effective_date: row.effective_date ?? row.edate,
      comm_plan_id: this.asExportTextId(row.comm_plan_id ?? row.commPlanId),
    };
  }

  private asExportTextId(value: unknown): string {
    if (value == null || value === '') {
      return '';
    }
    return String(value).trim();
  }

  private getExportCellValue(row: Record<string, unknown>, dataKey?: string): unknown {
    if (!dataKey) {
      return '';
    }

    const aliasKeys = this.exportFieldAliases[dataKey] ?? [dataKey];
    for (const key of aliasKeys) {
      const value = row[key];
      if (value != null && value !== '') {
        return value;
      }
    }
    return '';
  }

  private readonly exportFieldAliases: Record<string, string[]> = {
    employee_id: ['employee_id', 'employeeId'],
    sc_emp_id: ['sc_emp_id', 'id'],
    complan1: ['complan1', 'commission_plan', 'comPlan'],
    complan2: ['complan2', 'comPlanTwo'],
    complan3: ['complan3', 'comPlanThree'],
    effective_date: ['effective_date', 'edate'],
    profileStatus: ['profileStatus', 'profile_status'],
    comm_plan_id: ['comm_plan_id', 'commPlanId'],
  };

  private buildExcelReportData(dataRows: unknown[]): { title: string | null, data: unknown[][], headers: string[] } {
    const firstRow = (dataRows.length ? dataRows[0] : {}) as Record<string, unknown>;
    const headers = Object.keys(firstRow);
    return {
      title: this.commSummaryModel.reporttype,
      data: dataRows.map((row: unknown) => Object.values((row ?? {}) as Record<string, unknown>)),
      headers
    };
  }

  private toErrorMessage(error: HttpErrorResponse): string {
    return error?.error?.message || error?.message || 'Unexpected error';
  }

}